import React from 'react';
import { formats } from '../data/sushiContent';
export function FormatsSection() {
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby="formats-title" data-id="element-143" data-mp="3o84v46pigzdv">
      <div className="mx-auto max-w-6xl px-5" data-id="element-144" data-mp="3ah01bl8tr1bg">
        <p className="text-center text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-145" data-mp="3ae43dwwz8cn0">
          Sin enrollar
        </p>
        <h2 id="formats-title" className="mt-3 text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-146" data-mp="30hixzah1ozin">
          Los 7 formatos
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-[14px] leading-snug text-body" data-id="element-147" data-mp="2rinsk0ltrtge">
          Siete maneras de armar sushi que no necesitan esterilla, técnica ni paciencia.
        </p>

        <ul className="mt-8 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-3" data-id="element-148" data-mp="praqrkf5m1ok">
          {formats.map(f => <li key={f.name} className="flex flex-col border border-charcoal-600 bg-charcoal-800" data-id="element-149" data-mp="uoke8uizg39r">
              <img src={f.image} alt={`Sushi ${f.name} — ${f.line}`} className="aspect-[4/3] w-full object-cover" width={1200} height={900} loading="lazy" data-id="element-150" data-mp="k2yk3fd71nja" />
              <div className="flex flex-1 flex-col px-4 py-3.5" data-id="element-151" data-mp="sw25c9u2z4oh">
                <h3 className="font-display text-lg font-semibold uppercase leading-none text-ivory-50 sm:text-xl" data-id="element-152" data-mp="56r1gjhfou64">
                  {f.name}
                </h3>
                <p className="mt-auto pt-1.5 text-[10px] font-medium uppercase tracking-[0.18em] text-champagne" data-id="element-153" data-mp="f3vriueeh9s7">
                  {f.line}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}